import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { FaAngellist } from 'react-icons/fa'
import './footer.css';
import countapi from 'countapi-js';

const Footer = () => {
  countapi.visits().then((result) => {
    console.log(result.value);
  });
  return (
    <footer className='footer1'>
      <a href="#home" className="footer__logo">Vivek Nemade</a>
      <ul className="permalinks">
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Skills</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        {/* <li><a href="#testimonials">Testimonials</a></li> */}
        <li><a href="#contact">Contact</a></li>
      </ul>
      <div className="footer__socials">
      <a href="https://www.linkedin.com/in/vivek-nemade/" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
      <a href="https://github.com/Vivek-Nemade" target="_blank" rel="noreferrer" ><FaGithub /></a>
      </div>
      <div className="footer__copyright">
        {/* <p>Email:- viveknemade11@gmail.com</p>
        <p>Mobile:- 7276898441</p> */}
      </div>
      
    </footer>
  )
}

export default Footer